export default __webpack_public_path__ + "static/me-sm-9fcfa8c79b1b2d332a17f5cbcea95229.png";